import { useEffect, useState } from "react";

/** 값이 ms 동안 변하지 않으면 그 값을 반환. 검색 입력 디바운싱용. */
export function useDebouncedValue<T>(value: T, ms = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = window.setTimeout(() => setDebounced(value), ms);
    return () => window.clearTimeout(t);
  }, [value, ms]);
  return debounced;
}
